// Vendor
import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
// Utils / constants
import { NOTE_ALERT, NOTE_ASSET, NOTE_SECURITY, NOTE_WATCHLIST } from 'NotesApp/ts/apps/notes-app/notes.constants';
import { NOTES_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
// NgRx
import { deleteNote, fetchNotes, saveNote, setNotesFetchFailure, setNotesFetchSuccess, setSelectedNote, } from 'NotesApp/ts/apps/notes-app/state/notes.actions';
import { NOTES_MODAL_SLICE_KEY } from 'NotesApp/ts/apps/notes-app/state/notes.constants';
import { getNotesItems, getNotesStateFetchRequest } from 'NotesApp/ts/apps/notes-app/state/notes.selectors';
// Services
import { SecurityNotesService } from 'NotesApp/ts/apps/notes-app/services/security-notes.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { WatchlistsService } from 'WatchlistApp/ts/services/watchlists.service';
import { AlertNotesService } from 'AlertsApp/ts/services/alert-notes.service';
import { AssetNotesService } from 'NotesApp/ts/apps/notes-app/services/asset-notes.service';
// Components
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "NotesApp/ts/apps/notes-app/services/security-notes.service";
import * as i3 from "WatchlistApp/ts/services/watchlists.service";
import * as i4 from "AlertsApp/ts/services/alert-notes.service";
import * as i5 from "NotesApp/ts/apps/notes-app/services/asset-notes.service";
import * as i6 from "@ngrx/store";
import * as i7 from "@angular/common";
import * as i8 from "../../../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i9 from "@angular/forms";
import * as i10 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i11 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i12 from "../notes-list/notes-list.component";
const _c0 = ["featureNeededComponent"];
const _c1 = a0 => ({ disabled: a0 });
function NotesModalComponent_div_2_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 16);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r2.saveMessage === "Save successful" ? "text-green" : "text-red");
    i0.ɵɵproperty("textContent", ctx_r2.saveMessage);
} }
function NotesModalComponent_div_2_ycn_notes_list_15_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-notes-list", 17);
    i0.ɵɵlistener("sharingCallback", function NotesModalComponent_div_2_ycn_notes_list_15_Template_ycn_notes_list_sharingCallback_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.getNotes()); })("deleteHandler", function NotesModalComponent_div_2_ycn_notes_list_15_Template_ycn_notes_list_deleteHandler_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.deleteHandler($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("enableSharing", ctx_r2.enableSharing)("notesValue", ctx_r2.notes)("name", ctx_r2.parentModelInfo.name)("sharing", ctx_r2.parentModelInfo.sharing)("noteType", ctx_r2.noteType);
} }
function NotesModalComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "ycn-simple-modal-header", 4);
    i0.ɵɵlistener("closeModalHandler", function NotesModalComponent_div_2_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.closeModal()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 5)(3, "div", 6)(4, "div", 7);
    i0.ɵɵtext(5, "New Note");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 8)(7, "textarea", 9);
    i0.ɵɵtwoWayListener("ngModelChange", function NotesModalComponent_div_2_Template_textarea_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r2.noteText, $event) || (ctx_r2.noteText = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("keydown", function NotesModalComponent_div_2_Template_textarea_keydown_7_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.keyPressHandler($event)); });
    i0.ɵɵtext(8, "                        ");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "div", 10)(10, "div", 11);
    i0.ɵɵtemplate(11, NotesModalComponent_div_2_div_11_Template, 1, 3, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 13)(13, "div", 14);
    i0.ɵɵlistener("click", function NotesModalComponent_div_2_Template_div_click_13_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.noteText && ctx_r2.saveHandler()); });
    i0.ɵɵtext(14, " Save ");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(15, NotesModalComponent_div_2_ycn_notes_list_15_Template, 1, 5, "ycn-notes-list", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 10);
    i0.ɵɵelement(17, "div", 13);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("header", "Notes for " + ctx_r2.parentModelInfo.name);
    i0.ɵɵadvance(6);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.noteText);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r2.saveMessage);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(i0.ɵɵpureFunction1(6, _c1, !ctx_r2.noteText));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.isOpen);
} }
function NotesModalComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 5)(2, "div", 6)(3, "div", 18)(4, "div", 19);
    i0.ɵɵtext(5, "Loading Notes...");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "div", 20);
    i0.ɵɵelementEnd()()()();
} }
function NotesModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "ycn-simple-modal-header", 4);
    i0.ɵɵlistener("closeModalHandler", function NotesModalComponent_div_4_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.closeModal()); });
    i0.ɵɵtext(2, "? > ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 5)(4, "div", 6)(5, "div", 21);
    i0.ɵɵtext(6, " Notes failed to load ");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "div", 10);
    i0.ɵɵelement(8, "div", 13);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("header", "Notes for " + ctx_r2.parentModelInfo.name);
} }
/**
 * NotesModalComponent.
 *
 * Main component for the Notes Modal. Contains an input for adding the Notes and NotesListComponent.
 */
export class NotesModalComponent {
    constructor(featureService, securityNotesService, watchlistsService, alertNotesService, assetNotesService, store) {
        this.featureService = featureService;
        this.securityNotesService = securityNotesService;
        this.watchlistsService = watchlistsService;
        this.alertNotesService = alertNotesService;
        this.assetNotesService = assetNotesService;
        this.store = store;
        this.enableSharing = true;
        this.closeHandler = new EventEmitter();
        this.updateHandler = new EventEmitter();
        this.notesFetchStatus = 'none';
        this.isOpen = false;
        this.noteText = '';
        this.mapStateToComponent = (state) => {
            this.notes = getNotesItems(state);
            this.notesFetchStatus = getNotesStateFetchRequest(state).status;
            if (this.parentModelInfo?.id) {
                this.updateHandler.emit({ id: this.parentModelInfo.id, notes: this.notes });
            }
        };
        this.storeSubscription = this.store.select(NOTES_MODAL_SLICE_KEY).subscribe(this.mapStateToComponent);
        this.noteItemServiceNameMap = {
            [NOTE_SECURITY]: securityNotesService,
            [NOTE_WATCHLIST]: watchlistsService,
            [NOTE_ALERT]: alertNotesService,
            [NOTE_ASSET]: assetNotesService,
        };
    }
    ngOnInit() {
        this.noteItemService = this.noteItemServiceNameMap[this.noteType];
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    /**
     * Calls NotesService to fetches the Notes for the Security, and then updates the state.
     */
    getNotes() {
        if (this.parentModelInfo?.id) {
            this.noteItemService.getNotes(this.parentModelInfo.id, this.parentModelInfo.type).subscribe({
                next: (notes) => {
                    this.store.dispatch(setNotesFetchSuccess({ notes }));
                },
                error: (error) => {
                    this.store.dispatch(setNotesFetchFailure({ error }));
                },
            });
        }
    }
    /**
     * Opens the Notes Modal if the user has the notes feature. Otherwise,
     * the feature needed modal is opened.
     */
    openModal() {
        if (!this.featureService.userHasFeatures([NOTES_FEATURE])) {
            this.featureNeededComponent.openModal(NOTES_FEATURE);
        }
        else {
            this.store.dispatch(fetchNotes());
            this.getNotes();
            this.isOpen = true;
        }
    }
    /**
     * Closes the Notes Modal.
     */
    closeModal() {
        this.saveMessage = undefined;
        this.noteText = '';
        this.isOpen = false;
        this.closeHandler.emit();
    }
    /**
     * Handler for the `keydown` event for the Note creation input. If the event is `enter`, saves the current value as
     * a new Note.
     * @param ev: Pressed Key.
     */
    keyPressHandler(ev) {
        if (ev.key === 'Enter' && this.noteText.length > 0) {
            this.saveHandler();
        }
    }
    /**
     * Saves a new Note and updates the state.
     */
    saveHandler() {
        this.saveMessage = undefined;
        if (this.parentModelInfo?.id) {
            this.noteItemService
                .createNote(this.parentModelInfo.id, this.noteText, this.parentModelInfo.type)
                .subscribe({
                next: (note) => {
                    this.store.dispatch(saveNote({ note }));
                    this.saveMessage = 'Save successful';
                    this.noteText = '';
                },
                error: () => {
                    this.saveMessage = 'Save failed';
                },
            });
        }
    }
    /**
     * Deletes a Note and updates the state.
     * @param noteId: Note id.
     */
    deleteHandler(noteId) {
        this.noteItemService.deleteNote(noteId).subscribe({
            next: () => {
                this.store.dispatch(deleteNote({ noteId }));
                this.store.dispatch(setSelectedNote({ selectedNote: {} }));
            },
            error: () => { },
            complete: () => { },
        });
    }
}
NotesModalComponent.ɵfac = function NotesModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NotesModalComponent)(i0.ɵɵdirectiveInject(i1.FeatureService), i0.ɵɵdirectiveInject(i2.SecurityNotesService), i0.ɵɵdirectiveInject(i3.WatchlistsService), i0.ɵɵdirectiveInject(i4.AlertNotesService), i0.ɵɵdirectiveInject(i5.AssetNotesService), i0.ɵɵdirectiveInject(i6.Store)); };
NotesModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NotesModalComponent, selectors: [["ycn-notes-modal"]], viewQuery: function NotesModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededComponent = _t.first);
    } }, inputs: { enableSharing: "enableSharing", parentModelInfo: "parentModelInfo", noteType: "noteType" }, outputs: { closeHandler: "closeHandler", updateHandler: "updateHandler" }, standalone: false, decls: 7, vars: 6, consts: [["featureNeededComponent", ""], [3, "closeModalHandler", "focusElementId", "open"], [3, "ngSwitch"], [4, "ngSwitchCase"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], [1, "modal-section-title"], [1, "form-row"], ["id", "noteInput", "type", "text", "rows", "1", "placeholder", "Enter note text...", 1, "form-control", 3, "ngModelChange", "keydown", "ngModel"], [1, "modal-footer"], [1, "modal-footer-info"], [3, "class", "textContent", 4, "ngIf"], [1, "modal-footer-actions"], ["data-test-id", "save", 1, "btn", "btn-primary", 3, "click"], [3, "enableSharing", "notesValue", "name", "sharing", "noteType", "sharingCallback", "deleteHandler", 4, "ngIf"], [3, "textContent"], [3, "sharingCallback", "deleteHandler", "enableSharing", "notesValue", "name", "sharing", "noteType"], [1, "loader"], [1, "loader-message"], [1, "loader-spinner"], [1, "text-red"]], template: function NotesModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function NotesModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementStart(1, "div", 2);
        i0.ɵɵtemplate(2, NotesModalComponent_div_2_Template, 18, 8, "div", 3)(3, NotesModalComponent_div_3_Template, 7, 0, "div", 3)(4, NotesModalComponent_div_4_Template, 9, 1, "div", 3);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(5, "ycn-feature-needed", null, 0);
    } if (rf & 2) {
        i0.ɵɵproperty("focusElementId", "noteInput")("open", ctx.isOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngSwitch", ctx.notesFetchStatus);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngSwitchCase", "success");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngSwitchCase", "pending");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngSwitchCase", "error");
    } }, dependencies: [i7.NgIf, i7.NgSwitch, i7.NgSwitchCase, i8.FeatureNeededComponent, i9.DefaultValueAccessor, i9.NgControlStatus, i9.NgModel, i10.ModalBaseComponent, i11.SimpleModalHeaderComponent, i12.NotesListComponent], encapsulation: 2 });
